<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar flat dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-sm-and-up" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Dienstleistung bearbeiten</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon :disabled="!valid" v-show="$vuetify.breakpoint.xs" @click.native="updateService">
             <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Name"
                  v-model="service.name"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-currency-field
                  label="Private Vergütung pro Stunde"
                  v-model="service.privateHourFee"
                  v-bind="currencyConfig"
                ></v-currency-field>
              </v-flex>
              <v-flex xs6>
                <v-currency-field
                  label="Gewerbliche Vergütung pro Stunde"
                  v-model="service.businessHourFee"
                  v-bind="currencyConfig"
                ></v-currency-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="hidden-xs-only">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">Abbrechen</v-btn>
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="primary"
          text
          @click.native="updateService">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'EditServiceDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      service: {
        type: Object,
        default: function () {
          return {
            name: '',
            privateHourFee: 0.0,
            businessHourFee: 0.0
          }
        }
      }
    },
    data () {
      return {
        valid: false,
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        currencyConfig: {
          decimal: ',',
          thousands: '.',
          prefix: '€ ',
          precision: 2
        }
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      }
    },
    methods: {
      updateService () {
        this.$store.dispatch('editService', {
          id: this.service.id,
          name: this.service.name,
          privateHourFee: this.service.privateHourFee,
          businessHourFee: this.service.businessHourFee
        })
          .finally(() => this.$emit('close'))
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Services/EditServiceDialog.vue